import { useState, useRef, useEffect, useCallback } from 'react';

// Control segmentado Liquid Glass: la pastilla activa VIAJA de una opción a otra
// (mismo efecto del sidebar). options: [{label,value}] o ['a','b'].
export default function Segmented({ options, value, onChange, size = 'md', style }) {
  const opts = options.map(o => (typeof o === 'string' ? { label: o, value: o } : o));
  const wrapRef = useRef(null);
  const refs = useRef([]);
  const [pill, setPill] = useState({ left: 0, width: 0, ready: false });
  const activeIdx = Math.max(0, opts.findIndex(o => o.value === value));

  const measure = useCallback(() => {
    const el = refs.current[activeIdx];
    if (el) setPill({ left: el.offsetLeft, width: el.offsetWidth, ready: true });
  }, [activeIdx]);

  useEffect(() => { measure(); }, [measure, opts.length]);
  useEffect(() => {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  const pad = size === 'sm' ? '5px 12px' : '7px 15px';
  const fs = size === 'sm' ? 11.5 : 12.5;

  return (
    <div ref={wrapRef} className="ic-seg" style={{
      position: 'relative', display: 'inline-flex', gap: 2, padding: 4,
      maxWidth: '100%', overflowX: 'auto',
      background: 'var(--glass)', border: '1px solid var(--glass-brd)', borderRadius: 14,
      WebkitBackdropFilter: 'blur(16px) saturate(1.5)', backdropFilter: 'blur(16px) saturate(1.5)',
      boxShadow: 'inset 0 1px 0 var(--glass-hi)', ...style,
    }}>
      <div style={{
        position: 'absolute', top: 4, bottom: 4, left: pill.left, width: pill.width,
        borderRadius: 10, background: 'var(--pill-bg)', border: '1px solid var(--pill-brd)',
        boxShadow: 'inset 0 1px 0 var(--glass-hi), 0 4px 16px var(--pill-glow)',
        WebkitBackdropFilter: 'blur(10px)', backdropFilter: 'blur(10px)',
        transition: pill.ready
          ? 'left 0.42s cubic-bezier(0.34,1.35,0.44,1), width 0.42s cubic-bezier(0.34,1.35,0.44,1)'
          : 'none',
        opacity: pill.ready ? 1 : 0, pointerEvents: 'none', zIndex: 0,
      }} />
      {opts.map((o, i) => (
        <button key={o.value} ref={el => (refs.current[i] = el)}
          onClick={() => onChange(o.value)}
          style={{
            position: 'relative', zIndex: 1, padding: pad, border: 'none', background: 'transparent',
            borderRadius: 10, fontSize: fs, fontWeight: value === o.value ? 600 : 500,
            cursor: 'pointer', whiteSpace: 'nowrap',
            color: value === o.value ? 'var(--text)' : 'var(--text-3)',
            transition: 'color 0.18s ease',
          }}>{o.label}</button>
      ))}
    </div>
  );
}
